import { useLingui } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";
import { classNames } from "@offstreetparking/design-system/utils";
type ExpiryTimeOptionsProps = {
	activeExpiryOption: "time" | "duration" | "step";
	onDurationClicked: () => void;
	onPickTimeClicked: () => void;
	isDurationDisabled: boolean;
};
export const ExpiryTimeOptions = ({
	activeExpiryOption,
	onDurationClicked,
	onPickTimeClicked,
	isDurationDisabled,
}: ExpiryTimeOptionsProps) => {
	const { t } = useLingui();
	return (
		<div className="mb-2 flex w-full items-center gap-4 rounded-md bg-neutral-faded p-2">
			<button
				type="button"
				onClick={onDurationClicked}
				disabled={isDurationDisabled}
				className={classNames(
					"w-full rounded-md border border-neutral bg-white px-3 py-1.5",
					activeExpiryOption === "duration"
						? "border-primary bg-primary/10 ring-2 ring-primary ring-offset-[-1px]"
						: "",
					isDurationDisabled ? "cursor-not-allowed opacity-50" : "",
				)}
			>
				<Text size="sm">{t`Duration`}</Text>
			</button>

			<button
				type="button"
				className={classNames(
					"w-full rounded-md border border-neutral bg-white px-3 py-1.5",
					activeExpiryOption === "time"
						? "border-primary bg-primary/10 ring-2 ring-primary ring-offset-[-1px]"
						: "",
				)}
				onClick={onPickTimeClicked}
			>
				<Text size="sm">{t`Pick Time`}</Text>
			</button>
		</div>
	);
};
